import { render, staticRenderFns } from "./PromotionTable.vue?vue&type=template&id=64ceb159&scoped=true"
import script from "./PromotionTable.vue?vue&type=script&lang=js"
export * from "./PromotionTable.vue?vue&type=script&lang=js"
import style0 from "./PromotionTable.vue?vue&type=style&index=0&id=64ceb159&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ceb159",
  null
  
)

export default component.exports